import React from 'react';
import {Box, IconButton, InputAdornment} from '@mui/material';
import {AurTextField} from '../common/aur-text-field/AurTextField';
import {ReactComponent as SendIcon} from '../../assests/svg/send_icon_enable.svg';
import {ReactComponent as DisableSendIcon} from '../../assests/svg/send_icon_disable.svg';
import styles from './style.module.scss';
import {t} from 'i18next';

const MIN_ROWS = 1;
const MAX_ROWS = 5;
const WORD_LIMIT = 1000;

type ItemProps = {
  query: string;
  disabled: boolean;
  setQuery: React.Dispatch<React.SetStateAction<string>>;
  onHandleSend: (query: string) => void;
};

const AurQuerySubmissionBox: React.FC<ItemProps> = ({
  query,
  disabled = false,
  setQuery,
  onHandleSend,
}) => {
  const handleQueryChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (value.length > WORD_LIMIT) {
      setQuery(value.slice(0, WORD_LIMIT));
    } else {
      setQuery(value);
    }
  };

  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      if (!disabled && query.trim()) onHandleSend(query);
    }
  };

  return (
    <Box>
      <AurTextField
        className={`${styles.aurAskLioQuerySubmissionField} ${styles.aurAskLioQueryTextBox}`}
        value={query}
        onKeyPress={handleKeyPress}
        onChange={handleQueryChange}
        placeholder={t('buttons.askYourOwnQuestion')}
        ariaLabel={t('askLio.searchTextField.inputFiledAriaLable')}
        variant="outlined"
        fullWidth
        multiline
        minRows={MIN_ROWS}
        maxRows={MAX_ROWS}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                onClick={() => onHandleSend(query)}
                disabled={!query.trim() || disabled}
                className={styles.aurAskLioSendBtn}
                aria-label={
                  !query.trim() || disabled
                    ? t('askLio.searchTextField.enterDisabledAriaLable')
                    : t('askLio.searchTextField.enterEnabledAriaLable')
                }
                tabIndex={0}
              >
                {!query.trim() || disabled ? (
                  <DisableSendIcon aria-hidden="true" />
                ) : (
                  <SendIcon
                    aria-label={t(
                      'askLio.searchTextField.enterEnabledAriaLable'
                    )}
                  />
                )}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
    </Box>
  );
};

export default AurQuerySubmissionBox;
